@if (showBanner()) {
  @if (isDemo()) {
    <div class="banner-container" [class.collapsed]="isCollapsed()">
      <span class="banner-text">
        You're currently exploring the Demo Company — data resets in
        {{ daysUntilReset() }} Day(s). Switch or create a company in
        <strong class="banner-action" (click)="navigateToMyCompanies()">My Companies</strong>.
      </span>
    </div>
  } @else {
    <div class="banner-container" [class.collapsed]="isCollapsed()">
      Your Free Trial ends in {{ license()?.daysLeft }} Day(s).&nbsp; <strong style="cursor:pointer" (click)="navigateToPlan()">Upgrade
      &nbsp;</strong> your plan today!
    </div>
  }
}
